import axiosInstance from '../app/axios';
import ProviderAdminDTO from '../shared/dtos/providerAdminDTO';
import ProviderDTO from '../shared/dtos/providerDTO';

interface PaginatedProviderProps {
  page: number;
  take: number;
  filters?: string;
}

export const getPaginatedProviders = async ({
  page,
  take,
  filters,
}: PaginatedProviderProps) => {
  const result = await axiosInstance.get(
    `admin/providers?page=${page}&take=${take}${filters ? `&filters=${filters}` : ""
    }`,
  );
  return result.data;
};

export const createProvider = async (provider: ProviderAdminDTO) => {
  const result = await axiosInstance.post("admin/providers", provider);

  return result.data;
};

export const updateProvider = async (
  id: number,
  provider: Partial<ProviderAdminDTO>,
) => {
  const result = await axiosInstance.post(`admin/providers/${id}`, provider);

  return result.data;
};

export const getProviderById = async (id: number): Promise<ProviderDTO | null> => {
  const result = await axiosInstance.get(`admin/providers/${id}`);
  return result.data;
};

export const approveProvider = async (id: number) => {
  const result = await axiosInstance.post(
    `admin/providers/approval/${id}`,
    {},
  );

  return result.data;
};

export const getProvidersExcel = async () => {
  const result = await axiosInstance.get("admin/providers/information/excel");
  return result.data.file;
};

export const patchIsAdminProvider = async (
  id: number,
  isAdminProvider: boolean,
) => {
  const result = await axiosInstance.patch(
    `admin/providers/isAdminProvider/${id}`,
    { isAdminProvider },
  );

  return result.data;
};

export const patchIsBlackListed = async (id: number, flag: boolean) => {
  const result = await axiosInstance.patch(`admin/providers/${id}/blacklist`, {
    flag,
  });

  return result.data;
};
